import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  icon: {
    right: '8px',
  },
}));

type Option = {
  id: number,
  value: string,
  text: string,
  selected?: boolean,
};

type Props = {
  label?: string,
  defaultValue?: string,
  options: Array<Option>,
  onChange: Event,
};

export default function CustomSelect(props: Props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    value: '',
  });

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const handleChange = name => event => {
    setState({
      ...state,
      [name]: event.target.value,
    });

    props.onChange(event);
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel
        ref={inputLabel}
        htmlFor={`outlined-${props.label}-native-simple`}
      >
        {props.label}
      </InputLabel>
      <Select
        IconComponent={props => (
          <i
            {...props}
            className={`material-icons ${props.className} ${classes.icon}`}
          >
            keyboard_arrow_down
          </i>
        )}
        native
        value={props.defaultValue || state.value}
        onChange={handleChange('value')}
        input={
          <OutlinedInput
            name={props.label}
            labelWidth={labelWidth}
            id={`outlined-${props.label}-native-simple`}
          />
        }
      >
        {/* <option value="" /> */}
        {props.options.map(option => {
          return (
            <option key={option.id} value={option.value}>
              {option.text}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
}
